export default __webpack_public_path__ + "static/media/uang-muka.9634017d.png";